<template>
    <v-dialog style="overflow-y: hidden;" :class="isMobile ? 'mobile-modal' : 'normal-modal'" v-model="dialogControl">
        <v-card class="dialog-card">
            <v-flex class="inner-card-flex">
                <v-row style="position: relative;">
                    <v-col cols="6" md="4">
                        <h2 :class="isMobile ? 'center' : ''">{{ title }}</h2>
                    </v-col>
                    <v-btn @click="dialogControl = false" class="top-right-close-btn" icon>
                        <v-icon>fas fa-times</v-icon>
                    </v-btn>
                </v-row>
                <v-container class="my-1" v-if="menuURL">
                    <iframe style="height: 90%;" :class="isMobile ? 'mobile-file-display' : 'file-display'" class="my-1" :src="menuURL" />
                    <v-row class="center" v-if="editable">
                        <site-button
                            @click-event="deleteMenuLink"
                            btnType="text"
                            text="Delete Menu"
                            colorClasses="secondary-icon"
                            iconColor="primary-icon"
                            :marginNumber="2"
                            :colNum="5"
                            iconString="fas fa-trash"
                        ></site-button>
                        <site-button
                            @click-event="switchMenuLink"
                            btnType="text"
                            text="Swap Menu"
                            colorClasses="secondary-icon"
                            iconColor="primary-icon"
                            :marginNumber="2"
                            :colNum="5"
                            iconString="fas fa-exchange-alt"
                        ></site-button>
                    </v-row>
                </v-container>
                <span v-else>No File Uploaded Yet</span>
            </v-flex>
        </v-card>
    </v-dialog>
</template>

<style scoped>
::v-deep .v-dialog{
    overflow-y: hidden !important;
    border-radius: 15px;
    height: 95%;
    max-height: 95% !important;
    max-width: 80%;
}

.dialog-card{
    height: 100%; 
    overflow-y: hidden;
}

.inner-card-flex{
    height: 100%; 
    overflow-y: auto; 
    margin-left: 0; 
    margin-right: 0;
}
</style>

<script>
import SiteButton from '../common/SiteButton.vue'

export default {
    components: {
        'site-button': SiteButton,
    },
    props: {
        showDialog: {
            type: Boolean,
            default: false,
        },
        menuURL: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: ''
        },
        editable: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        deleteMenuLink(){
            this.$emit('delete-link')
        },
        switchMenuLink(){
            this.$emit('switch-link')
        }
    },
    computed: {
        dialogControl: {
            get() {
                return this.showDialog
            },
            set(newVal) {
                console.log('newVal: ' + newVal)
                this.$emit('setDialogControl', newVal)
            },
        },
        isMobile() {
            return this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm'
        },
    },
}
</script>
